export default class ShopDropdownCollection extends HTMLElement {
    private dropdowns: HTMLElement[] = []

    constructor() {
        super()

        // Wait for child dropdowns to be defined
        window.addEventListener('DOMContentLoaded', () => {
            this.initializeDropdowns()
            // Add click event listener to document
            this.addEventListener('click', this.handleOutsideClick.bind(this))
        })
    }

    private initializeDropdowns() {
        this.dropdowns = Array.from(this.querySelectorAll<HTMLElement>('shop-dropdown'))

        this.dropdowns.forEach((dropdown) => {
            dropdown.addEventListener('click', () => {
                this.handleDropdownClick(dropdown)
            })
        })
    }

    private handleDropdownClick(clickedDropdown: HTMLElement) {
        // When a dropdown is clicked, update the borders of other dropdowns
        const allClosed = this.dropdowns.every((dropdown) => dropdown.getAttribute('open') === 'false')

        if (allClosed) {
            this.dropdowns.forEach((dropdown) => {
                const dropdownEl = dropdown.querySelector('[data-dropdown]') as HTMLElement
                dropdownEl?.style.setProperty('border-color', '#000000')
            })
            return
        }

        // Update the borders of all dropdowns
        this.dropdowns.forEach((dropdown) => {
            const dropdownEl = dropdown.querySelector('[data-dropdown]') as HTMLElement
            const isOpenAttribute = dropdown.getAttribute('open') === 'true'

            if (dropdown !== clickedDropdown && !isOpenAttribute) {
                dropdownEl?.style.setProperty('border-color', '#E5E5E5')
            } else {
                dropdownEl?.style.setProperty('border-color', '#000000')
            }
        })
    }

    private handleOutsideClick(event: MouseEvent) {
        const target = event.target as HTMLElement
        // Only process clicks that are inside the collection but outside individual dropdowns
        if (this.contains(target)) {
            const clickedInsideDropdown = this.dropdowns.some((dropdown) => dropdown.contains(target))
            if (!clickedInsideDropdown) {
                this.dropdowns.forEach((dropdown: any) => {
                    dropdown.isOpen = false
                    const dropdownEl = dropdown.querySelector('[data-dropdown]') as HTMLElement
                    dropdownEl?.style.setProperty('border-color', '#000000')
                })
            }
        }
    }
}

customElements.define('shop-dropdown-collection', ShopDropdownCollection)
